module.exports = __webpack_public_path__ + "media/images/hero_images/security-1200-c4927af897ff5b5cf18591976eed15f4.png";